import React from "react";
import classes from "../UI/Spinner/ItemLoader.module.css";

export default function MessagesLoader() {
  return (
    <div
      className={classes.Item}
      style={{
        marginTop: "15px",
        border: "none",
        width: "100%",
      }}
    >
      <div className={`${classes.ItemInfo} ${classes.wide}`}>
        <div className={classes.Header}></div>
        <div className={classes.Content}></div>
      </div>
    </div>
  );
}
